
import { injectSpeedInsights } from '@vercel/speed-insights/nuxt/runtime'
import { defineNuxtPlugin } from '#imports'

export default defineNuxtPlugin(() => {
  injectSpeedInsights()
})
